<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12" v-for="item in data" :key="item.Id">
        <div class="card mb-3 shadow-sm">
          <div class="card-body">
            <h5 class="card-title">
              {{ $t('message.case_filling_info.vocabulary.court') }}: {{ item.Court }}
            </h5>
            <p class="mb-1">
              <strong>{{ $t('message.case_filling_info.vocabulary.punish_date') }}:</strong>
              {{ item.PunishDate }}
            </p>
            <p class="mb-1">
              <strong>{{ $t('message.case_filling_info.vocabulary.case_reason') }}:</strong>
              {{ item.CaseReason }}
            </p>

            <p class="mb-1">
              <strong>{{ $t('message.case_filling_info.vocabulary.prosecutors') }}:</strong>
              <span v-for="(pros, index) in item.ProsecutorList" :key="index" class="mr-2">
                {{ pros.Name }}
              </span>
            </p>

            <p class="mb-1">
              <strong>{{ $t('message.case_filling_info.vocabulary.defendants') }}:</strong>
              <span v-for="(def, index) in item.DefendantList" :key="index" class="mr-2">
                {{ def.Name }}
              </span>
            </p>

            <div v-for="(role, rIndex) in item.RoleList" :key="rIndex" class="mt-2">
              <strong>{{ role.RoleName }}:</strong>
              <ul class="mb-0 pl-3">
                <li v-for="(person, pIndex) in role.RoleItemList" :key="pIndex">
                  {{ person.Name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    imLoaded: {
      type: Function,
      default: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.imLoaded) {
        this.imLoaded();
      }
    });
  },
};
</script>